import { useMemo } from 'react';

import { ExternalLink } from '@/common/constants';
import { PROD_ENV_KEY } from '@/utils/hooks/useEnvSpecificAvailable';
import { whiteLabelingConfig } from '@/utils/whiteLabeling';
import { THEMES } from '@/utils/whiteLabeling/whiteLabelingConfig';

const isProd = (window.REACT_APP_ENV || import.meta.env.REACT_APP_ENV) === PROD_ENV_KEY;

const usePartnerLoginConfig = () => {
  const partnerLoginConfigs = useMemo(
    () => [
      {
        themeKey: THEMES.rippling,
        buttonText: 'Sign In Using Rippling',
        loginUrl: ExternalLink.ripplingLogin,
      },
      {
        themeKey: THEMES.gusto,
        buttonText: 'Sign in to Gusto',
        loginUrl: isProd ? ExternalLink.gustoProdLogin : ExternalLink.gustoDemoLogin,
      },
    ],
    []
  );

  const partnerLoginConfig = partnerLoginConfigs.find(
    (partner) => whiteLabelingConfig.key === partner.themeKey
  );

  return {
    partnerLoginConfig,
  };
};

export default usePartnerLoginConfig;
